// Services
import { tmxApiCall } from './index'

// Utilities
import Logger from '../utility/loggerUtil'

export default {
  /**
   * Logs an analytic event in Iterable.
   * @param {String} email - The email address of the customer.
   * @param {String} dataFields - The properties and values for the analytic event.
   * @param {String} eventName - The name of the analytic event.
   */
  async logIterableEvent (email, dataFields, eventName) {
    Logger.info('Started log event request.')

    return tmxApiCall('post', '/iterableEvent', {
      email,
      dataFields,
      eventName
    })
  },

  /**
   * Creates a users profile in Iterable.
   * @param {String} email - The email address of the customer.
   */
  async createIterableProfile (email) {
    Logger.info('Started create Iterable profile request.')

    return tmxApiCall('post', '/iterableProfile', {
      email
    })
  },

  /**
   * Updates Iterable user profile.
   * @param {String} email - The email address of the customer.
   * @param {String} dataFields - The properties to add/update in Iterable.
   */
  async updateIterableProfile (email, dataFields) {
    Logger.info('Started update Iterable profile request.')

    return tmxApiCall('put', '/iterableProfile', {
      email,
      dataFields
    })
  },

  /**
   * Updates CleverTap profile by verifying email address.
   * @param {String} email - The email address of the customer.
   * @param {String} mdmId - The mdmId of the customer.
   */
  async verifyCleverTapEmail (email, mdmId) {
    Logger.info('Started Verify CleverTap Email post.')
    return tmxApiCall('post', '/verifyCleverTapEmail', {
      email,
      mdmId
    })
  }
}
